export default __webpack_public_path__ + "static/media/PadronSeries.1716b927.png";